import { type LoaderFunctionArgs, redirect } from 'react-router';
import { generateFriendInfoQueryOptions } from '@/hooks/users/use-friend-info';
import ROUTES from '@/routes';
import { getUserId } from '@/stores/auth';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export async function userByIdLayoutLoader({ params, request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);
  const { userId } = ROUTES.CONTACT.USERS.BY_ID.$deserializeParams(params);
  const { groupId, source = 'avatar' } = ROUTES.CONTACT.USERS.BY_ID.$deserializeSearchParams(searchParams);

  if (getUserId() === userId) {
    return redirect(ROUTES.MY.INFO.$path());
  }

  const queryOptions = generateFriendInfoQueryOptions(userId);
  await queryClient.invalidateQueries(queryOptions);
  const friendInfo = await queryClient.ensureQueryData(queryOptions).catch(catchFetcherError);

  if (!friendInfo?.IsFriend) {
    return redirect(ROUTES.CONTACT.REQUEST.USER.$buildPath({ searchParams: { id: userId, groupId, source } }));
  }

  return {
    friendInfo,
  };
}
